import { ACTIONS } from "UTILS/Constants";

export const setLogoImage = (logo) => {
  return {
    type: ACTIONS.SET_LOGO_URL,
    logo,
  };
};

export const setSharingFlag = (value) => {
  return {
    type: ACTIONS.SET_MEDIA_SHARING_STOP,
    value,
  };
};

export const setSdpFlag = (value) => {
  return {
    type: "SET_START_SDP_OFFER",
    value,
  };
};

export const setIncomingCallFlag = (value) => {
  return {
    type: "SHOW_INCOMING_CALL",
    value,
  };
};

export const setQrError = (value) => {
  return {
    type: ACTIONS.SET_QR_ERROR,
    value,
  };
};

export const setQrActiveScreen = (activeQRScreen) => {
  return {
    type: ACTIONS.SET_QR_ACTIVE_SCREEN,
    activeQRScreen,
  };
};

export const setQrLicenseKey = (qrLicenseKey) => {
  return {
    type: ACTIONS.SET_QR_LICENSE_KEY,
    qrLicenseKey,
  };
};

export const removeSessionKeyAndToken = () => {
  return {
    type: ACTIONS.REMOVE_TOKEN_SESSION_KEY,
  };
};

export const updateLatestParticipant = () => {
  return {
    type: ACTIONS.UPDATE_PARTICIPANTS,
    participant: null,
  }
}

export const setSessionStatus = (sessionStatus) => {
  return {
    type: ACTIONS.SET_SESSION_STATUS,
    sessionStatus,
  }
}

export const removeSessionDetails = () =>{
  return {
    type: ACTIONS.JOIN_SESSION,
    sessionDetails: {sessionKey:'', token:'', modules:[]},
  }
}

export const setIsDisabledMenu = (value) => {
  return {
    type: ACTIONS.SET_IS_DISABLED_MENU,
    value,
  }
}